import { render, staticRenderFns } from "./FileNow.vue?vue&type=template&id=87e62bfa&scoped=true&"
import script from "./FileNow.vue?vue&type=script&lang=js&"
export * from "./FileNow.vue?vue&type=script&lang=js&"
import style0 from "./FileNow.vue?vue&type=style&index=0&id=87e62bfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e62bfa",
  null
  
)

export default component.exports